import styles from "./style.module.scss";
import TopImage from "src/assets/faq_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Access" />
        <div className={styles.titleBox}>
          <h1>Access</h1>
          <p>アクセス</p>
        </div>
      </div>
    </section>
  );
};
